import {
  GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties_multipleChoice_options,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties_multipleChoice_options_cropData,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties_multipleChoice_options_image,
} from 'approot/activity-builder/__generated__/GetActivitiesSections';
import { ComponentMultipleChoice } from '../component.constants';

type BaseProps = Omit<ComponentMultipleChoice, '__typename'>;
export type ViewProps = BaseProps;
export type EditProps = ViewProps;
export type PrintProps = BaseProps;

export type MultipleChoiceProperties = GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties;
export type MultipleChoiceOption = GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties_multipleChoice_options;
export type MultipleChoiceCropData = GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties_multipleChoice_options_cropData;
export type MultipleChoiceImage = GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties_multipleChoice_options_image;

export const ANSWER_LABELS = 'ABCDEF';
export const CORRECT = 'correct';
export const INCORRECT = 'incorrect';
